import type { LeagueTeamPlayers } from '@library/types/player';

export const filterBoardBuilderGamePlayers = ({
  gamePlayers,
  searchValue,
  selectedTeams,
  selectedPositions
}: {
  gamePlayers: LeagueTeamPlayers | undefined;
  searchValue: string;
  selectedTeams: Array<string>;
  selectedPositions: Array<string>;
}) => {
  if (!gamePlayers?.length) {
    return gamePlayers;
  }

  const selectedTeamsPlayers = selectedTeams.length
    ? gamePlayers?.filter((player) => selectedTeams.includes(player.team))
    : gamePlayers;

  const selectedPositionsPlayers = selectedPositions.length
    ? selectedTeamsPlayers?.filter((player) =>
        selectedPositions.includes(player.position)
      )
    : selectedTeamsPlayers;

  const filteredPlayers = !searchValue
    ? selectedPositionsPlayers
    : selectedPositionsPlayers?.filter((player) =>
        player.normalizedName?.toUpperCase().includes(searchValue.toUpperCase())
      );

  return filteredPlayers;
};
